export { default as images } from "./images";

export const PERCENTOFF = {
  label: "2",
  value: "0.02",
};
